import gql from 'graphql-tag';

import { RutrConsolidatedEventFragment, RutrEventFragment } from './fragments';

export const GetRutrTimeline = gql`
  query rollUpTheRimTimelineByTHLegacyCognitoId($cognitoId: String!, $eventId: String) {
    rollUpTheRimTimelineByTHLegacyCognitoId(cognitoId: $cognitoId, eventId: $eventId) {
      count
      events {
        ...RutrEventFragment
      }
    }
  }
  ${RutrEventFragment}
`;

export const GetRutrConsolidatedTimeline = gql`
  query rollUpTheRimConsolidatedTimelineByTHLegacyCognitoId($cognitoId: String!, $eventId: String) {
    rollUpTheRimConsolidatedTimelineByTHLegacyCognitoId(cognitoId: $cognitoId, eventId: $eventId) {
      count
      events {
        ...RutrConsolidatedEventFragment
      }
    }
  }
  ${RutrConsolidatedEventFragment}
`;
